// Header coming from Cloudflare request transform rules
export const MARKET_COUNTRY_CODE = 'bm-market'
